export interface PublicRuntimeConfig {
  gaMeasurementId: string;
  recaptchaSiteKey: string;
  analyticsEnabled: boolean;
  recaptchaEnabled: boolean;
}

// Always use same-origin proxy route — backend URL is never exposed to the browser.
const PUBLIC_CONFIG_ENDPOINT = "/api/cache/marketing-public-config";

const DEFAULT_CONFIG: PublicRuntimeConfig = {
  gaMeasurementId: "",
  recaptchaSiteKey: "",
  analyticsEnabled: false,
  recaptchaEnabled: false,
};

let configPromise: Promise<PublicRuntimeConfig> | null = null;

async function fetchPublicConfig(endpoint: string): Promise<PublicRuntimeConfig> {
  const res = await fetch(endpoint, {
    method: "GET",
    headers: { Accept: "application/json" },
  });
  if (!res.ok) return DEFAULT_CONFIG;

  const contentType = res.headers.get("content-type") || "";
  if (!contentType.includes("application/json")) return DEFAULT_CONFIG;

  let data: Partial<PublicRuntimeConfig>;
  try {
    data = (await res.json()) as Partial<PublicRuntimeConfig>;
  } catch {
    return DEFAULT_CONFIG;
  }

  return {
    gaMeasurementId: String(data.gaMeasurementId || ""),
    recaptchaSiteKey: String(data.recaptchaSiteKey || ""),
    analyticsEnabled: Boolean(data.analyticsEnabled),
    recaptchaEnabled: Boolean(data.recaptchaEnabled),
  };
}

export function getPublicRuntimeConfig(): Promise<PublicRuntimeConfig> {
  if (configPromise) return configPromise;

  configPromise = fetchPublicConfig(PUBLIC_CONFIG_ENDPOINT)
    .then((cfg) => cfg)
    .catch(() => DEFAULT_CONFIG);

  return configPromise;
}
